<div class="image-viewer" (keydown)="keyhandler($event)">
  <div class="col-1">
    <mat-menu #menu="matMenu">
      <button mat-menu-item *ngFor="let day of imageActivity" (click)="hopToDate($event)">{{day.label}}</button>
    </mat-menu>
    <div class="img-info" *ngIf="landscape">
      <h2 class="info-header">
        Image info
        <button mat-button (click)="toggleInfo()" title="Image info" [disabled]="false && !selectedImg"><i class="far fa-times"></i></button> 
      </h2>
      <h3>Timestamp: {{selectedImg?.timestamp}}</h3>
      <h3>File: <a [href]="selectedImg?.url" target="_blank">{{selectedImg?.filename}}</a></h3>
      <button mat-raised-button color="primary" (click)="downloadImage(selectedImg)" title="Download image" class="dl-btn" [disabled]="!selectedImg">Download</button>

      <h2>Observations</h2>
      <form>
        <table>
          <tr>
            <th class="insectname">Insect</th>
            <th class="insectcount">Count</th>
            <th class="boardtype">Glue board</th>
            <th class="pheremones">Pheremones</th>
            <th class="insectnotes">Notes</th>
            <th class="insectdel"></th>
          </tr>
          <ng-container *ngFor="let observation of observations">
            <tr>
              <td class="insectname">
                <mat-form-field appearance="fill" class="w-100-p">
                  <input matInput placeholder="Insect type" (input)="updateRow($event, observation, 'insectname')" [value]="observation.insect_type || ''"/>
                </mat-form-field>
              </td>
              <td class="insectcount">
                <mat-form-field appearance="fill" class="w-100-p">
                  <input matInput type="number" placeholder="0" (input)="updateRow($event, observation, 'insectcount')" [value]="observation.insect_count || ''"/>
                </mat-form-field>
              </td>
              <td class="boardtype">
                <mat-form-field appearance="fill" class="w-100-p">
                  <input matInput placeholder="N/A" (input)="updateRow($event, observation, 'boardtype')" [value]="observation.board || ''"/>
                </mat-form-field>
              </td>
              <td class="pheremones">
                <mat-form-field appearance="fill" class="w-100-p">
                  <input matInput placeholder="N/A" (input)="updateRow($event, observation, 'pheremones')" [value]="observation.pheremones || ''"/>
                </mat-form-field>
              </td>
              <td class="insectnotes">
                <mat-form-field appearance="fill" class="w-100-p">
                  <input matInput placeholder="N/A" (input)="updateRow($event, observation, 'insectnotes')" [value]="observation.notes || ''"/>
                </mat-form-field>
              </td>
              <td class="insectdel">
                <button mat-button (click)="deleteRow(observation.id)" title="Download image" [disabled]="!selectedImg"><i class="fas fa-times"></i></button>
              </td>
            </tr>
          </ng-container>
          <tr>
            <td>
              <button mat-raised-button color="primary" class="addbtn" (click)="addRow()" [disabled]="observationsLoading">Add</button>
            </td>
          </tr>
        </table>
      </form>
    </div>
    <div class="thumbnails-outer">
      <div class="thumbnails" (scroll)="scrollhandler($event)" [class.center-align]>
        <!-- has thumbnails -->
        <ng-container *ngIf="images.length > 0">
          <div id="tr-3a" *ngIf="!prevExhausted">
            <div><i class="fas fa-spinner-third"></i></div>
          </div> 
          <ng-container *ngFor="let image of images; let i = index">
            <h2 class="date-header" *ngIf="images[i - 1]?.dateStr !== images[i].dateStr">
              {{image.dateStr}}
            </h2>
            <a class="thumbnail" (click)="selectIndex(i)" [class.selected]="i == selectedIndex">
              <img [src]="image.thumbnailUrl">
              <div class="timestamp">{{image.timeStr}}</div>
            </a>
          </ng-container>
          <div id="tr-3b" *ngIf="!nextExhausted">
            <div><i class="fas fa-spinner-third"></i></div>
          </div>
        </ng-container>

        <!-- no thumbnails -->
        <ng-container *ngIf="images.length == 0">
          <div id="tr-3c" *ngIf="loadingnext">
            <div><i class="fas fa-spinner-third"></i></div>
          </div>
          <div id="no-images" *ngIf="!loadingnext">
            <i class="fas fa-images"></i>
            <span>No images found</span>
          </div>
        </ng-container>
      </div>

    </div>
    <div class="actions" *ngIf="!isInfoOpen">
      <button mat-button [matMenuTriggerFor]="menu"> <mat-icon>calendar_today</mat-icon></button>
    </div>
  </div>
  <div class="col-2">
    <div class="panel-container">
      <div class="img-info" *ngIf="!landscape">
        <h2 class="info-header">
          Image info
          <button mat-button (click)="toggleInfo()" title="Image info" [disabled]="false && !selectedImg"><i class="far fa-times"></i></button> 
        </h2>
        <h3>Timestamp: {{selectedImg?.timestamp}}</h3>
        <h3>File: <a [href]="selectedImg?.url" target="_blank">{{selectedImg?.filename}}</a></h3>
        <button mat-raised-button color="primary" (click)="downloadImage(selectedImg)" title="Download image" class="dl-btn" [disabled]="!selectedImg">Download</button>

        <h2>Observations</h2>
        <form>
          <table>
            <tr>
              <th class="insectname">Insect</th>
              <th class="insectcount">Count</th>
              <th class="boardtype">Glue board</th>
              <th class="pheremones">Pheremones</th>
              <th class="insectnotes">Notes</th>
              <th class="insectdel"></th>
            </tr>
            <ng-container *ngFor="let observation of observations">
              <tr>
                <td class="insectname">
                  <mat-form-field appearance="fill" class="w-100-p">
                    <input matInput placeholder="Insect type" (input)="updateRow($event, observation, 'insectname')" [value]="observation.insect_type || ''"/>
                  </mat-form-field>
                </td>
                <td class="insectcount">
                  <mat-form-field appearance="fill" class="w-100-p">
                    <input matInput type="number" placeholder="0" (input)="updateRow($event, observation, 'insectcount')" [value]="observation.insect_count || ''"/>
                  </mat-form-field>
                </td>
                <td class="boardtype">
                  <mat-form-field appearance="fill" class="w-100-p">
                    <input matInput placeholder="N/A" (input)="updateRow($event, observation, 'boardtype')" [value]="observation.board || ''"/>
                  </mat-form-field>
                </td>
                <td class="pheremones">
                  <mat-form-field appearance="fill" class="w-100-p">
                    <input matInput placeholder="N/A" (input)="updateRow($event, observation, 'pheremones')" [value]="observation.pheremones || ''"/>
                  </mat-form-field>
                </td>
                <td class="insectnotes">
                  <mat-form-field appearance="fill" class="w-100-p">
                    <input matInput placeholder="N/A" (input)="updateRow($event, observation, 'insectnotes')" [value]="observation.notes || ''"/>
                  </mat-form-field>
                </td>
                <td class="insectdel">
                  <button mat-button (click)="deleteRow(observation.id)" title="Download image" [disabled]="!selectedImg"><i class="fas fa-times"></i></button>
                </td>
              </tr>
            </ng-container>
            <tr>
              <td>
                <button mat-raised-button color="primary" class="addbtn" (click)="addRow()" [disabled]="observationsLoading">Add</button>
              </td>
            </tr>
          </table>
        </form>
      </div>
      <div class="viewer-header">
        <h1 [class]="!selectedImg ? 'halfpac' : ''">
          {{selectedImg ? (selectedImg.dateStr + ' ' + selectedImg.timeStr) : 'Images' }}
        </h1>
        <button [disabled]="!selectedImg" mat-button (click)="toggleInfo()" class="info-btn" title="Image info" [disabled]="false && !selectedImg"><i class="fas fa-circle-info"></i></button> 
      </div>
      <div class="image-container">
      <img [src]="selectedImg?.url" id="main-image" (click)="toggleFullscreen()" />
      <button mat-button class="arrow left" (click)="selectIndex(selectedIndex - 1)" *ngIf="images.length > 0" [disabled]="selectedIndex == 0 && prevExhausted">
        <i class="fas fa-chevron-left"></i>
      </button>
      <button mat-button class="arrow right" (click)="selectIndex(selectedIndex + 1)" *ngIf="images.length > 0" [disabled]="selectedIndex == (images.length - 1) && nextExhausted">
        <i class="fas fa-chevron-right"></i>
      </button> 
      </div>
    </div>
  </div>



  
<!-- Fullscreen overlay -->
  <div class="fullscreen-overlay" *ngIf="isFullscreen" (click)="toggleFullscreen()">
    <button class="arrow left" (click)="selectIndex(selectedIndex - 1)">
      <i class="fa-solid fa-chevron-left"></i>
    </button>
    <img [src]="selectedImg?.url" alt="Fullscreen image" class="fullscreen-image" />
    <button class="arrow right" (click)="selectIndex(selectedIndex + 1)">
      <i class="fa-solid fa-chevron-right"></i>
    </button>
    <button class="download-btn fullscreen" (click)="downloadImage(selectedImg, $event)" title="Download image">
      <i class="fa-light fa-arrow-down-to-line"></i>
    </button>
  </div>
</div>